module.exports = __webpack_public_path__ + "img/a1.648c6271.jpg";